import React from "react";
import TestStatusTableRow from "containers/request/Initial/TestStatusTableRow";
import LabTestInfoContainerCRR from "containers/request/CRR/LabTestInfoContainerCRR";

const customTitles = {
  col1: "Test",
  col2: "Lab",
  col3: "Status",
  col1Row: "Battery Compliance"
};

const LabTestInfoCRR = ({ editable }) => {
  return (
    <LabTestInfoContainerCRR
      editable={editable}
      customTitles={customTitles}
      statusComponent={TestStatusTableRow}
    />
  );
};

export default LabTestInfoCRR;
